import { render, staticRenderFns } from "./Blogviewer.vue?vue&type=template&id=347c8e65&"
import script from "./Blogviewer.vue?vue&type=script&lang=js&"
export * from "./Blogviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports